"use client";
// Grupo del menú principal con desplegable: se cierra al elegir, al tocar fuera o con Escape.
import { useEffect, useRef } from "react";
import { Enlace } from "@/components/Enlace";

export function NavGrupo({ etiqueta, items }: { etiqueta: string; items: { href: string; txt: string; nota?: string }[] }) {
  const ref = useRef<HTMLDetailsElement>(null);
  useEffect(() => {
    const cerrar = () => ref.current?.removeAttribute("open");
    const fuera = (e: Event) => { if (ref.current?.open && !ref.current.contains(e.target as Node)) cerrar(); };
    const tecla = (e: KeyboardEvent) => { if (e.key === "Escape") cerrar(); };
    document.addEventListener("pointerdown", fuera); document.addEventListener("keydown", tecla);
    return () => { document.removeEventListener("pointerdown", fuera); document.removeEventListener("keydown", tecla); };
  }, []);
  return (
    <details ref={ref} className="nav-grupo">
      <summary>{etiqueta}<span aria-hidden="true"> ▾</span></summary>
      <div className="nav-grupo-panel">
        {items.map((i) => <Enlace key={i.href} href={i.href} onClick={() => ref.current?.removeAttribute("open")}><b>{i.txt}</b>{i.nota && <small>{i.nota}</small>}</Enlace>)}
      </div>
    </details>
  );
}
